import React from 'react'
import { Link } from "react-router-dom";
import "./menu.scss"

const Menu = () => {
  return (
    <div className="menu">
      <div className="item">
        <span className="title">MAIN</span>
        <Link to="/" className="listItem">
          <img src="/home.svg" alt="" />
          <span className="listItemTitle">Home</span>
        </Link>
        <Link to="/missiondispatch" className="listItem">
          <img src="/order.svg" alt="" />
          <span className="listItemTitle">Dispo</span>
        </Link>
        <Link to="/" className="listItem">
          <img src="/profile.svg" alt="" />
          <span className="listItemTitle">Profil</span>
        </Link>
      </div>
      <div className="item">
        <span className="title">Struktur</span>
        <Link to="/organizations" className="listItem">
          <img src="/organizsations.svg" alt="" />
          <span className="listItemTitle">Organisationen</span>
        </Link>
        <Link to="/users" className="listItem">
          <img src="/user.svg" alt="" />
          <span className="listItemTitle">Benutzer</span>
        </Link>
        <Link to="/ressources" className="listItem">
          <img src="/truck.svg" alt="" />
          <span className="listItemTitle">Einsatzmittel</span>
        </Link>
        <Link to="/" className="listItem">
          <img src="/pager.svg" alt="" />
          <span className="listItemTitle">RICs</span>
        </Link>
        <Link to="/" className="listItem">
          <img src="/profile.svg" alt="" />
          <span className="listItemTitle">Benutzer</span>
        </Link>
      </div>
    </div>
  )
}

export default Menu